import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0012776b&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs-edu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0012776b')) {
      api.createRecord('0012776b', component.options)
    } else {
      api.reload('0012776b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0012776b&", function () {
      api.rerender('0012776b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/settlement/index.vue"
export default component.exports